<div class="container mt-3 mb-3">
    <app-mat-spinner-overlay [overlay]="true" *ngIf="loading"></app-mat-spinner-overlay>

  <mat-accordion *ngIf="filterForm">
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Filtrar Postos
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="mt-2"  [formGroup]="filterForm">
        <div class="row">
          <div class="col-3">
            <mat-form-field class="w-100">
              <mat-label>Código</mat-label>
              <input type="text" matInput formControlName="codPosto" (input)="onCodPostoInput($event)"
                (keyup)="onCodPostoInput($event)" placeholder="Números separados por virgula" autocomplete="off" />
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="w-100">
              <mat-label>Nome</mat-label>
              <input matInput formControlName="nomePosto" />
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="w-100">
              <mat-label>Fantasia</mat-label>
              <input matInput formControlName="nomeFantasia" />
            </mat-form-field>
          </div>

          <div class="col-3">
            <mat-form-field class="w-100">
              <mat-label>Grupo</mat-label>
              <input matInput formControlName="descricaoRede" autocomplete="off" />
            </mat-form-field>
          </div>
        </div>

        <div class="row">

          <div class="col">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>CNPJ</mat-label>
              <input matInput formControlName="cnpj" autocomplete="off" />
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Vinculados a macro?</mat-label>
              <mat-select formControlName="vinculado">
                <mat-option value="">Todos</mat-option>
                <mat-option value="sim">Vinculados</mat-option>
                <mat-option value="nao">Não vinculados</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col d-flex gap-2 btns-busca">
            <button mat-flat-button color="accent" type="button" (click)="applyFilter()">
              Consultar
              <mat-icon>search</mat-icon>
            </button>
            <button matButton="outlined" mat-flat-button type="button" (click)="clearFilter()">Limpar Filtro
              <mat-icon>delete</mat-icon></button>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <div class="row mt-2 mb-2">
    <div class="col d-flex justify-content-end align-items-center gap-2">
      <button mat-flat-button type="button" (click)="exportToExcel()">
        <mat-icon>description</mat-icon>
        <span> Exportar Excel</span>
      </button>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" matSort class="w-100">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox style="padding-right: 4px;"
        (change)="masterToggle()" [checked]="isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()" color="accent"></mat-checkbox>

           Vinculado a Macro?
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="alterouCheckBox($event, row)"
          [checked]="row.postoAtrelado"
          color="accent">
        </mat-checkbox>
      </td>


      <ng-container matColumnDef="descricaoRede">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Grupo</th>
        <td mat-cell *matCellDef="let posto">{{ posto.descricaoRede }}</td>
      </ng-container>

    </ng-container>
    <ng-container matColumnDef="codPosto">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
      <td mat-cell *matCellDef="let posto">{{ posto.codPosto.toString().padStart(5, '0') }}</td>
    </ng-container>

    <ng-container matColumnDef="nomeFantasia">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Fantasia</th>
      <td mat-cell *matCellDef="let posto">{{ posto.nomeFantasia }}</td>
    </ng-container>
    <ng-container matColumnDef="nomePosto">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
      <td mat-cell *matCellDef="let posto">{{ posto.nomePosto }}</td>
    </ng-container>

    <!-- descricao da rede -->
    <ng-container matColumnDef="cnpj">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>CNPJ</th>
      <td mat-cell *matCellDef="let posto">{{ posto.cnpj }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
  </table>


  <mat-paginator [pageSize]="25" [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons></mat-paginator>
  <div class="row mt-2">
    <div class="col text-end">
      <button mat-flat-button matTooltip="Salvar alterações feitas na tabela" matTooltipPosition="above"
        matTooltipShowDelay="500" matTooltipHideDelay="100" aria-label="Salvar alterações feitas na tabela"
         (click)="salvarAlteracoes()" color="accent" type="button">
        <mat-icon>description</mat-icon>
        <span>Salvar Alteraçoes</span>
      </button>
    </div>
  </div>

</div>